import React from "react";
import { Outlet } from "react-router-dom";

import { useAuth } from "../components/auth/AuthenticationContext";
import { Loader } from "component-library";

export const RequireBoot: React.FC = () => {
  const { state } = useAuth();

  if (state === "BOOTING") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  return <Outlet />;
};
